import { useEffect } from 'react';

const EVENT_NAME = 'idealist::dropdown::request-close-all';

//  NOTE: these functions exist to allow us avoid prop drilling
// (e.g. in SearchFacets where the  code relies on MapChildren)
export const requestCloseAllDropdowns = () => {
  window.dispatchEvent(new CustomEvent(EVENT_NAME));
};

export const useOnCloseAllDropdowns = (closeHandler: () => void) => {
  useEffect(() => {
    const handleCloseAll = () => {
      closeHandler();
    };

    window.addEventListener(EVENT_NAME, handleCloseAll);

    return () => {
      window.removeEventListener(EVENT_NAME, handleCloseAll);
    };
  }, [closeHandler]);
};
